import { writable } from 'svelte/store';
export function createStore($state) {
    const store = writable($state);
    function set(data) {
        for (const field of Object.keys(data)) {
            $state[field] = data[field];
        }
        store.set($state);
    }
    return {
        set,
        $state,
        readable: {
            $state,
            subscribe: store.subscribe,
            acknowledgeError() {
                set({ error: undefined });
            },
        },
    };
}
